import React from 'react'
import ExelJS, {TableColumnProperties} from 'exceljs'
import {FactoryBalanceModel} from '../models'
import moment from 'moment'

const SHEET_NAME = 'Ganancias'
const COLUMNS: TableColumnProperties[] = [
  {name: 'Fecha', filterButton: true},
  {name: 'Número de factura', filterButton: true},
  {name: 'Descripción', filterButton: true},
  {name: 'Anticipo', totalsRowFunction: 'sum'},
  {name: 'Abono', totalsRowFunction: 'sum'},
  {name: 'Saldo', totalsRowFunction: 'custom', totalsRowFormula: 'factory_balance[[#Totals],[Anticipo]]-factory_balance[[#Totals],[Abono]]'},
]

const useGenerateExel = (getData: () => Promise<FactoryBalanceModel[]>) => {
  const createExel = async () => {
    const wb = new ExelJS.Workbook()
    const sheet = wb.addWorksheet(SHEET_NAME, {
      views: [{state: 'frozen', ySplit: 1}],
    })

    const data = await getData()

    sheet.getColumn('A').width = 11
    sheet.getColumn('B').width = 30
    sheet.getColumn('C').width = 30
    sheet.getColumn('D').width = 20
    sheet.getColumn('E').width = 20
    sheet.getColumn('F').width = 20
    sheet.getColumn('D').style.numFmt = '$#,##0.00;[Red]-$#,##0.00'
    sheet.getColumn('E').style.numFmt = '$#,##0.00;[Red]-$#,##0.00'
    sheet.getColumn('F').style.numFmt = '$#,##0.00;[Red]-$#,##0.00'

    sheet.addTable({
      name: 'factory_balance',
      ref: 'A1',
      headerRow: true,
      totalsRow: true,
      columns: COLUMNS,
      style: {
        theme: 'TableStyleLight1',
        showRowStripes: true,
      },
      rows: data.map((d) => [
        moment(d.createdAt).utcOffset(0, true).utcOffset(-5).toDate(),
        d.reference,
        d.detail,
        d.advance,
        d.payment,
				d.balance,
      ]),
    })

    return wb.xlsx.writeBuffer()
  }

  const download = async () => {
    try {
      const buffer = await createExel()
      const content = new Blob([buffer])

      const uri = window.URL.createObjectURL(content)
      const link = document.createElement('a')

      link.setAttribute('href', uri)
      link.setAttribute('download', 'Cartera_de_fábricas.xlsx')

      link.click()
    } catch (error) {
      console.log(error)
    }
  }

  return download
}

export default useGenerateExel
